<template>
    <observaciones :listPath="listPath" :createPath="createPath" :editPath="editPath"
      :canEdit="canEdit" payloadId="cuota" :id="cuotaId"/>
</template>

<script>
import Observaciones from '../../pago_a_jugadores/components/Observaciones'

export default {
  components: {
    Observaciones
  },
  props: {
    cuotaId: [Number, String],
    canEdit: Boolean
  },

  data () {
    return {
      observacionText: '',
      editable: true,
      editing: false,
      listPath: `cuota/${this.cuotaId}/observaciones`,
      createPath: `cuota/observacion/${this.cuotaId}/new`,
      editPath: 'cuota/observacion'
    }
  }
}
</script>
